import React, { useEffect, useState } from "react";
import i18next from "i18next";
import classes from '../AnnualRemuneration.module.css'

export const ARSearchRow = ({rows = [], scrollToRow = ()=>{}}) => {

  const [searchValue, setSearchValue] = useState("");
  const [rowIds, setRowIds] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  let timeout = null;

  useEffect(() => {
    const ids = getRowIdsBySearch(searchValue);
    setRowIds(ids);
    scrollToRow(ids, currentIndex);
  }, [searchValue, rows]);

  useEffect(() => {
    scrollToRow(rowIds, currentIndex);
  }, [currentIndex]);

  const getRowIdsBySearch = (searchValue) => {
    const ids = [];
    if (searchValue) {
      searchValue = searchValue.toLowerCase();
      rows.forEach((row, index) => {
        const {OrgStructIdView: pId, OrgStructShortName: pName, OrgStructName: pFullName} = row;
        if (pId?.toLowerCase().indexOf(searchValue) >= 0 || pName?.toLowerCase().indexOf(searchValue) >= 0 || pFullName?.toLowerCase().indexOf(searchValue) >= 0 ) {
          ids.push(index);
        }
      });
    }
    setCurrentIndex(0);
    return ids;
  }

  const handleInput = (e) => {
    setSearchValue(e.target.value);
  }

  const clearSearch = (e) => {
    setSearchValue("");
  }

  const changeCurrentIndex = (value = 0) => {
    let newIndex = currentIndex + value;
    if (newIndex < 0) {
      newIndex = rowIds.length - 1;
    } else if (newIndex >= rowIds.length) {
      newIndex = 0;
    }
    setCurrentIndex(newIndex);
  }

  return (
    <>
      <div className={`${classes.searchFormActions}`}>
        <div>{!!rowIds.length && `${currentIndex + 1}/${rowIds.length}`}</div>
        <i className={`zmdi zmdi-chevron-up`} onClick={() => changeCurrentIndex(-1)} />
        <i className={`zmdi zmdi-chevron-down`} onClick={() => changeCurrentIndex(1)} />
      </div>
      <div className={`${classes.searchForm}`}>
        <input className={"w-100"} onChange={handleInput} value={searchValue} placeholder={i18next.t("SearchLabel")} />
        <i className={"zmdi zmdi-close"} onClick={clearSearch} />
      </div>
    </>
  );
}